"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineWith = combineWith;
var compose_1 = __importDefault(require("lodash/fp/compose"));
var compact_1 = __importDefault(require("lodash/fp/compact"));
var join_1 = __importDefault(require("lodash/fp/join"));
(function () { return 'prevent false positive scan'; })();
/**
* Combine a set of strings with given divider.
*
* @example
* ```
* combineWith(' ')('foo', 'bar', 'boo') // 'foo bar boo'
* combineWith('-')('foo', undefined, null, 'bar', 'boo') // 'foo-bar-boo'
* combineWith('-')() // ''
* ```
* */
function combineWith(divider) {
    return function () {
        var strings = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            strings[_i] = arguments[_i];
        }
        return (0, compose_1.default)((0, join_1.default)(divider), compact_1.default)(strings);
    };
}
